import { call, cancel, fork, put, takeEvery } from "redux-saga/effects"
import {
  PUT_THIRD_PARTY_AGREEMENT,
  setSuccess,
  storeThirdPartyAgreement,
  storeAgreementSelectionModalIsOpen,
  storeTimeoutModalIsOpen,
  storeCircusAgreement,
} from "actions"
import { putThirdPartyInfo } from "apis/PutThirdPartyInfo"
import { callApi } from "sagas/Api"
import { handlingPutApiError } from "./CommonErrorHandling"
import { execTimeoutTimer } from "sagas/Timeout"

export function* handlePutThirdPartyAgreements() {
  yield takeEvery(PUT_THIRD_PARTY_AGREEMENT, execPutThirdPartyAgreements)
}

export function* execPutThirdPartyAgreements(action) {
  yield put(storeAgreementSelectionModalIsOpen(false))

  // API実行開始後に指定の秒数が経過後、タイムアウト処理を実行する
  const timeout = yield fork(execTimeoutTimer)

  const { payload, error } = yield call(
    callApi,
    putThirdPartyInfo,
    action.payload
  )

  yield cancel(timeout)
  yield put(storeTimeoutModalIsOpen(false))

  if (payload && !error) {
    yield put(storeThirdPartyAgreement(action.payload))

    // キャンペーン期間外のリクエストの場合
    if (
      payload.campaign !== undefined &&
      payload.campaign.isCampaign !== undefined &&
      payload.campaign.isCampaign === false
    ) {
      yield put(storeCircusAgreement({ campaign: { isCampaign: false } }))
    }

    yield put(setSuccess(payload))
  } else {
    yield call(handlingPutApiError, error)
  }
}
